import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { DocumentTypeELynkPacketAddMode } from 'src/app/models/document';
import { ActionService } from 'src/app/services/actions/action.service';
import { AlertService, MessageSeverity } from 'src/app/services/alert.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { DeleteElynkAddRequest, DeleteElynkAddResponse, SaveElynkAddRequest, SaveElynkAddResponse } from 'src/app/services/document-type/document-type-plugin-models';
import { ELynkPacket, ELynkPacketAdd } from 'src/app/services/document-type/document-type.model';
import { DocumentTypeBaseComponent } from '../../document-types-base.component';

@Component({
    selector: 'app-elynk-packet-add',
    templateUrl: 'elynk-packet-add.component.html',
    styleUrls: ['elynk-packet-add.component.scss']
})
export class ElynkPacketAddComponent extends DocumentTypeBaseComponent implements OnChanges {
    constructor(
        private alertService: AlertService,
        private confirmationService: ConfirmationService,
        public actionService: ActionService,
        public configurationService: ConfigurationService


    ) {
        super(configurationService, actionService);
    }

    addVisibleModes = DocumentTypeELynkPacketAddMode;
    initialSelectedPacket: ELynkPacket = JSON.parse(JSON.stringify(this.newPacket));

    @Input() documentTypeId: number;
    @Input() selectedPacket: ELynkPacket = this.newPacket;

    @Output() selectedPacketChange = new EventEmitter<ELynkPacket>();

    @ViewChild('packetAddForm', { static: false }) packetAddForm: NgForm;

    ngOnChanges(changes: SimpleChanges): void {
        setTimeout(() => {
            this.selectedPacket.add ??= new ELynkPacketAdd();
            this.setInitialPacket();
        });
    }

    async saveChanges(event) {
        try {
            const saveResponse = await this.savePacketAdd(this.documentTypeId, this.selectedPacket);

            if (saveResponse.statusCode === 200) {

                this.selectedPacketChange.emit(this.selectedPacket);
                this.setInitialPacket();
                this.packetAddForm.form.markAsPristine();

                this.alertService.showMessage('Packet "add" settings saved.', null, MessageSeverity.success);
            } else {
                this.alertService.showMessage('Failed to save packet "add" settings.', 'Unknown error ocurred during saving of packet add.', MessageSeverity.error);
            }

        } catch (error) {
            this.alertService.showMessage('Failed to save packet "add" settings.', error.error.Message, MessageSeverity.error);
        }
    }

    resetForm() {
        this.packetAddForm.resetForm(
            {
                visible: this.initialSelectedPacket.add.visible,
                editable: this.initialSelectedPacket.add.editable
            }
        );
    }

    clearForm() {
        this.packetAddForm.resetForm(
            {
                visible: null,
                editable: null
            }
        );
    }

    async deleteAdd(event) {
        const msg = `Are you sure you want to delete ${this.selectedPacket.id} add configuration?`;

        this.confirmationService.confirm({
            target: event.target,
            key: 'ElynkAddDeleteDialog',
            message: msg,
            accept: async () => {

                try {
                    const deleteResponse = await this.deletePacketAdd(this.documentTypeId, this.selectedPacket.id);

                    if (deleteResponse.statusCode === 200) {
                        this.clearForm();
                        this.selectedPacket.add = null;
                        this.alertService.showMessage('Add configuration deleted', null, MessageSeverity.success);
                    } else {
                        this.alertService.showMessage(`Failed to delete add configuration`, 'Unknown error ocurred during the deletion of packet add.', MessageSeverity.error);
                    }

                } catch (error) {
                    this.alertService.showMessage(`Failed to delete add configuration`, error.error.Message, MessageSeverity.error);
                }

            },
            reject: () => {
                return;
            }
        });

    }

    private setInitialPacket() {
        this.initialSelectedPacket = JSON.parse(JSON.stringify(this.selectedPacket));
    }

    private async savePacketAdd(documentTypeId: number, packet: ELynkPacket): Promise<SaveElynkAddResponse> {
        const request = new SaveElynkAddRequest(documentTypeId, packet.id, packet.add);
        let response = await this.actionService.invoke(this.ActionType, "elynk-add-add", request) as SaveElynkAddResponse;
        return response;
    }

    private async deletePacketAdd(documentTypeId: number, packetId: string): Promise<DeleteElynkAddResponse> {
        const request = new DeleteElynkAddRequest(documentTypeId, packetId);
        let response = await this.actionService.invoke(this.ActionType, "elynk-add-delete", request) as DeleteElynkAddResponse;
        return response;
    }

}
